import { render, staticRenderFns } from "./SimpleTextInputConfiguration.vue?vue&type=template&id=31d44955&scoped=true&"
import script from "./SimpleTextInputConfiguration.vue?vue&type=script&lang=js&"
export * from "./SimpleTextInputConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./SimpleTextInputConfiguration.vue?vue&type=style&index=0&id=31d44955&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d44955",
  null
  
)

export default component.exports